import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import {
  CombinedCondition,
  FilterModel,
} from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

import { OPERATORS_ALLOWING_EMPTY_VALUE } from "@app/component/filtering/utils/consts";
import { isCombinedCondition } from "@app/util/viewModel/assert";

const getFiltersCountInCombinedCondition = (
  condition: CombinedCondition,
  implicitFilterFieldsNames: Set<IField["filterName"]>
): number => {
  return condition.conditions.reduce((result, condition) => {
    if (isCombinedCondition(condition)) {
      return result + getFiltersCountInCombinedCondition(condition, implicitFilterFieldsNames);
    } else {
      return (
        result +
        ((condition.value !== undefined ||
          OPERATORS_ALLOWING_EMPTY_VALUE.includes(condition.operator)) &&
        !implicitFilterFieldsNames.has(condition.fieldFilterName)
          ? 1
          : 0)
      );
    }
  }, 0);
};

export const getAppliedFiltersCount = (filter: FilterModel, implicitFilterFields?: IField[]) => {
  const implicitFilterFieldsNames = new Set(
    (implicitFilterFields ?? []).map(({ filterName }) => filterName)
  );
  return getFiltersCountInCombinedCondition(filter, implicitFilterFieldsNames);
};
